import * as types from "./invoicesActionTypes";
import * as apiUrls from "./invoicesApiUrls";
import { checkUnreadNotifications } from "../notifications/actions";

// TODO: remove this and use BaseApi
import Cookies from "universal-cookie";
import fetchWithProgress from "../../utils/FetchWithProgress";

const cookies = new Cookies();

export function fetchInvoices(loadingCallback, withDraft=false) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2Invoices(withDraft), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => response.json())
    .then(json => {
      if(json instanceof Array) dispatch(receiveInvoices(json));
      loadingCallback();
    })
    .catch(error => {
      loadingCallback();
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

// TODO: Refactor to use endpoints scoped under /v2/user/
export function submitInvoices(body, onProgress, successCallback) {
  return (dispatch) => {
    return fetchWithProgress(apiUrls.apiV2Invoices(), {
        method: "POST",
        headers: { "Authorization": cookies.get("jwtToken") },
        body: body
      },
      onProgress,
    )
    .then((data) => {
      const { id, invoice_document } = JSON.parse(data);
      const { invoice_attachments } = invoice_document

      const draftData = {
        id,
        invoice_document,
        invoice_attachments,
      };

      successCallback(draftData);
      return dispatch(receiveInvoices(draftData));
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function updateInvoices(body) {
  return fetch(apiUrls.apiV2Invoices(), {
    method: "PUT",
    headers: new Headers({
      "Authorization": cookies.get("jwtToken"),
    }),
    body,
  })
}

export function updateInvoiceWithProgress(id, userID, body, successCallback, onProgress, json = false) {
  var headers = {
    "Authorization": cookies.get("jwtToken"),
  }

  if(json) {
    headers = {
      "Authorization": cookies.get("jwtToken"),
      "Content-Type": "application/json",
    }
  }

  return (dispatch) => {
    return fetchWithProgress(apiUrls.apiV2Invoice(id, userID),
      {
        method: "PUT",
        headers: headers,
        body: body,
      },
      onProgress
    )
    .then((json) => {
      successCallback(JSON.parse(json));
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  }
}

export function updateInvoice(id, userID, body, successCallback, json = false) {
  var headers = new Headers({
    "Authorization": cookies.get("jwtToken"),
  })

  if(json) {
    headers = new Headers({
      "Authorization": cookies.get("jwtToken"),
      "Content-Type": "application/json",
    })
  }

  return (dispatch) => {
    return fetch(apiUrls.apiV2Invoice(id, userID), {
      method: "PUT",
      headers: headers,
      body,
    })
    .then((response) => {
      if (response.ok) {
        response.json().then(json => {
          successCallback(json);
        })
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  }
}

export function fetchInvoice(id, userId, onSuccess, onError) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2Invoice(id, userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          if (!!json) {
            onSuccess(json);
            dispatch(receiveInvoices(json));
          }
          else onError();
        });
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function fetchInvoiceAttachments(id, userId, successCallback) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2InvoiceAttachments(id, userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          successCallback(json);
        });
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function fetchInvoiceNotifications(id, userId, successCallback) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2InvoiceNotifications(id, userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          successCallback(json);
        });
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function resolveInvoiceNotifications(body, id, userId, successCallback) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2InvoiceResolveNotifications(id, userId), {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
      body: JSON.stringify(body),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(checkUnreadNotifications());
          successCallback(json);
        });
      }
    });
  };
}

export function receiveInvoices(data) {
  return { type: types.RECEIVE_INVOICES, payload: data };
}

export function createInvoices(data) {
  return { type: types.CREATE_INVOICES, payload: data };
}

export function removeInvoices() {
  return { type: types.REMOVE_INVOICES, payload: [] }
}

export function filterInvoices(data) {
  return { type: types.FILTER_INVOICES, payload: data }
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/invoicesActions.js